import { ICellRendererParams } from 'ag-grid-enterprise'
import { selectThemeStyle } from '../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../redux/hooks.ts'
import IdeyaTypography from '../../common/antd/ideya-typography.tsx'

export const IsTrialCellRenderer: React.FC<ICellRendererParams> = (props) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  if (props.value)
    return (
      <div
        style={{
          display: 'flex',
          width: '80px',
          height: themeStyle.controlHeightLG,
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <IdeyaTypography.Text
          style={{
            display: 'flex',
            padding: `1px ${themeStyle.paddingXS}`,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            borderRadius: themeStyle.borderRadiusXS,
            background: `rgba(0, 0, 0, 0.08)`,
          }}
        >
          Trial
        </IdeyaTypography.Text>
      </div>
    )
  return <></>
}
